import axios from "axios";
import URL from "../config/api.json";

const tokens = async () => {
  const token = await axios.get(`${URL.API_URL}providers`);
  const resToken = token.data.data;
  return resToken;
};
const networks = async () => {
  const token = await axios.get(`${URL.API_URL}networks`);
  const resToken = token.data.data;
  return resToken;
};
const watchLists = async () => {
  const token = await axios.get(`${URL.API_URL}whales/watchlist`);
  const resToken = token.data.data;
  return resToken;
};
const postWatchlist = async (data) => {
  const bodyFormData = new FormData();
  bodyFormData.append("address", data.address);
  bodyFormData.append("network", data.network);
  const result = await axios({
    method: "post",
    url: `${URL.API_URL}whales/watchlist`,
    data: bodyFormData,
  });
  if(result.data.status === 1){
    return result.data;
  }else{
    return result.error;
  }
};

const delWatchlist = async (data) => {
  const bodyFormData = new FormData();
  bodyFormData.append("address", data.address);
  bodyFormData.append("network", data.network);
  const result = await axios({
    method: "delete",
    url: `${URL.API_URL}whales/watchlist`,
    data: bodyFormData,
  });
  if(result.data.status === 1){
    return result.data;
  }else{
    return result.error;
  }
};

export { tokens, networks, watchLists, postWatchlist,delWatchlist };
